import classNames from 'classnames'

import type { ReactElement } from 'react'
import type { IBlockProps } from '~/types/template'

import './styles.scss'

const FrameBlock = ({ className, color, onClick }: IBlockProps): ReactElement => {
  const classes = classNames('block frame-block', className)

  return <div className={classes} onClick={onClick} style={{ outlineColor: color }} />
}

export default FrameBlock
